import axios from 'axios'

export const getProfile = async (data) => {
    try {

        let result = await axios({
            method: 'post',
            url: `${process.env.REACT_APP_LINEOA_V2_HOST_API}/lineoa/profile`,
            data: {
                "line_id": data.line_id,
                "company_id": data.company_id,
                "is_detail": data.is_detail !== undefined ? data.is_detail : true
            }
        })

        return result

    } catch (error) {
        return error
    }

}

export const getIsCheckConsent = async (data) => {

    try {
        let res = await axios({
            method: 'post',
            url: `${process.env.REACT_APP_LINEOA_V2_HOST_API}/lineoa/check_accept_consent`,
            data: {
                "line_id": data.line_id,
                "company_id": data.company_id
            }
        })
        return res
    } catch (error) {
        return error
    }
}